import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
} from "@mui/material";

const ReferralHistory = () => {
  const referralData: any[] = [];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>Reffered To</TableCell>
            <TableCell>Reffered  On</TableCell>
            <TableCell>Earned Points</TableCell>
            <TableCell>Referral Code</TableCell>
            <TableCell>Referral Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {referralData.length > 0 ? (
            referralData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell> <div className="user_block"> <p> <b> {row.userDetail}</b> <span>{row.email}</span> <span>{row.phone}</span> </p></div></TableCell>
                <TableCell>{row.referralDate}</TableCell>
                <TableCell>{row.earnedPoints}</TableCell>
                <TableCell>{row.referralCode}</TableCell>
                <TableCell>       <p
                  className={`status_btn dark ${row.status === "Earned"
                      ? "c_success"
                      : row.status === "Pending"
                        ? "c_danger"
                        : "c_warning"
                    }`}
                >
                  {row.status}
                </p></TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">No data found</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReferralHistory;
